import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAnchorComponent } from './simple-icons-anchor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAnchorComponent ],
    exports:      [ SimpleIconsAnchorComponent ],
    bootstrap:    []
})
export class SimpleIconsAnchorModule {}
